export default __webpack_public_path__ + "static/media/Front-Sheyaaka-Production-House-4.10e35efb.jpg";